import { useQuery } from "@tanstack/react-query";

import QueryKeys from "@app/constants/QueryKeys.ts";
import { useUserService } from "@app/services/api/useUserService.ts";

export const useUser = (id: string) => {
  const { fetchUserById } = useUserService();

  const { data, error, isLoading } = useQuery({
    queryKey: [QueryKeys.USER, id],
    queryFn: () => fetchUserById(id),
  });

  return {
    user: data,
    error,
    isLoading,
  };
};
